export default function noop() {}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-geo/src/noop.js
// module id = gEqK
// module chunks = 0